import { Select } from 'antd';
import { Section } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import { setFormat } from '../flow/actions';

const formats = Enums.REPORTS.FORMATS_IN_ARRAY;

const propTypes = {
  format: PropTypes.string.isRequired
};

class FormatSection extends PureComponent {
  handleChange = newFormat => this.props.setFormat(newFormat);

  render() {
    const { format } = this.props;
    const i18n = 'page.ReportFilters';

    return (
      <Section title={<FormattedMessage id={`${i18n}.sectionNames.format`} />}>
        <Select
          className="full-width"
          size="small"
          value={format}
          onChange={this.handleChange}
        >
          {formats.map(f => (
            <Select.Option key={f} value={f}>
              {<FormattedMessage id={`${i18n}.formats.${f}`} />}
            </Select.Option>
          ))}
        </Select>
      </Section>
    );
  }
}

FormatSection.propTypes = propTypes;
const mapStateToProps = ({ global, reportSetup }) => ({
  lang: global.language,
  format: reportSetup.setup.format
});
const mapDispatchToProps = {
  setFormat
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormatSection);



// WEBPACK FOOTER //
// ./src/views/ReportFilters/components/FormatSection.jsx